import {
  detectClientFromPath,
  getClientConversationsRoute,
} from "./routeUtils";

/**
 * Extracts thread ID from the current URL path
 * @returns The thread ID from URL or undefined if not found
 */
export const extractThreadIdFromUrl = (): string | undefined => {
  const path = window.location.pathname;
  const threadId = path.split("/")[3];
  return threadId;
};

/**
 * Extracts conversation ID from the current URL
 * @returns Conversation ID or null if not found
 */
export function extractConversationId(): number | null {
  const pathSegments = window.location.pathname.split("/");
  const conversationsIndex = pathSegments.indexOf("conversations");

  if (conversationsIndex !== -1 && pathSegments[conversationsIndex + 1]) {
    const id = parseInt(pathSegments[conversationsIndex + 1], 10);
    return isNaN(id) ? null : id;
  }

  return null;
}

/**
 * Updates the URL with a new conversation ID
 * @param conversationId - The new conversation ID
 */
export function updateUrlWithConversationId(conversationId: number): void {
  // Detect client from current path
  const client = detectClientFromPath(window.location.pathname);
  const newPath = getClientConversationsRoute(
    client,
    conversationId.toString(),
  );

  // Update URL without triggering a page reload
  window.history.pushState({}, "", newPath);
}
